import React from "react"
import styled from "styled-components"
import breakpoint from "styled-components-breakpoint"

import { Column } from "../helpers"

const Footer = ({ children, prefooter, postfooter }) => (
  <Style>
    {prefooter}
    <Column>{children}</Column>
    {postfooter}
  </Style>
)
export default Footer

const Style = styled.footer.attrs((props) => ({
  className: "region--footer",
  role: "contentinfo",
}))`
  background-color: ${(props) => props.theme.colors.primary};
  display: flex;
  flex-wrap: wrap;
  font-size: 0.9em;

  > .site__column {
    padding-top: 24px;
    padding-bottom: 24px;
    display: grid;
    align-items: center;
    justify-content: space-between;
    line-height: 1;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    grid-template-columns: 1fr 1fr;

    ${breakpoint("md")`
            display: flex;
            padding-top: 2vmin;
            padding-bottom: 2vmin;
        `}

    nav {
      order: 1;
      width: 100%;

      ${breakpoint("md")`
                width: auto;
                order: 2;
                margin-left: 40px;
            `}
    }

    .brand {
      order: 2;

      ${breakpoint("md")`
                order: 4;
            `}
    }

    .extra-logos {
      order: 3;
      align-self: center;
      width: 100%;
      margin-top: 2rem;
      grid-column: 1 / 3;

      ${breakpoint("md")`
                margin-right: auto;
                width: auto;
                margin-left: 40px;
                margin-top: 0;
            `}

      ${breakpoint("xlg")`
                margin-top: 0;
                width: auto;
            `}
    }
  }

  .copyright {
    order: 3;
    grid-column: 2 / 3;

    ${breakpoint("md")`
            order: 1;
        `}

    p {
      text-align: right;
      font-size: 1em;
    }
  }

  .brand a {
    color: ${(props) => props.theme.colors.textColor};
    max-width: 100px;
    margin-bottom: 0.5rem;
    margin-left: auto;

    ${breakpoint("sm")`
            margin-bottom: 0;
            max-width: 131px;
        `}
  }
`
